export const GOOGLE_MAPS_API = "https://www.google.com/maps/embed/v1/place?key=AIzaSyBzMY7-uGV8b85mZI5R5X7j_bR9wcJ5hZ4&";
export const REQUEST_BIN_API = "https://6cef702b00ebf6849a44fbc57799499c.m.pipedream.net/?"